import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { TranslateService } from '@ngx-translate/core';
import { CircularService } from 'src/app/shared/services/circular.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { StepDecision, CircularsFixedRebateOptionDecisionHistory, Circular, CircularsFixedRebateOptions, CircularRequest, Percentages, CircularOptionRebate, RelatedRequests, OptionKey, Port } from 'src/app/shared/models/circular.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Router } from '@angular/router';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';
import { FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-circular-request-admin-decision',
  templateUrl: './circular-request-admin-decision.component.html'
})

export class CircularRequestAdminDecisionComponent implements OnInit {

  private decisionSelected: number = 0;
  private isAccept: boolean = false;
  public currentSelctedOption: string = null;
  private isRequireModification: boolean = false;
  public CircularsFixedRebateOptionDecisionHistory: CircularsFixedRebateOptionDecisionHistory = new CircularsFixedRebateOptionDecisionHistory();
  public AcceptOptionDecisionLoaded: CircularsFixedRebateOptionDecisionHistory = new CircularsFixedRebateOptionDecisionHistory();
  private AcceptOptionDecisionLoadedResponseObject: ResponseObject = new ResponseObject();
  private isReject: boolean = false;
  private isNegativeNumber: boolean = false;
  private CircularID;
  private ports: Port[] = [];
  private Countries: Country[] = [];
  private isOptionSubmitted: boolean = false;
  public Percentages: Percentages[] = [];
  public RequestOptions: CircularsFixedRebateOptions[] = [];
  private selectedCircularsFixedRebateOptions: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private AdminDecisionForm: FormGroup;
  private yearBuiltMaxDate: Date = new Date(Date.now());
  private optionsRebate: CircularsFixedRebateOptions[] = [];
  private selectedOption: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private isRebateOnlastTransit: boolean = false;
  private optionsArrayIndex: number = 0;
  private isFormSubmitted: boolean = false;
  @ViewChild('AdminDecision',{static: false}) AdminDecisionDTOControls: ElementRef;
  private RequestId: string = "";
  loading = false;
  @ViewChild('CircularRequest',{static: false}) CircularRequest: CircularRequestComponent;
  public isRequestSucceeded: boolean = false;
  private isSubmitEnabled: boolean = false;
  private RequestStatus: number;
  private getRelatedRequestsResponse: ResponseObject = new ResponseObject();
  private firstDecisionObject;
  public circulars: Circular[] = [];
  private OriginsArr: OptionKey[] = [];
  private DestinationsArr: OptionKey[] = [];
  private DestinationsArrPorts: OptionKey[] = [];
  private OriginsArrPorts: OptionKey[] = [];
  private DestinationsArrCountries: OptionKey[] = [];
  private OriginsArrCountries: OptionKey[] = [];
  private submitMeasurementCommitteeDecisionResponseObject: ResponseObject = new ResponseObject();
  public currentUser: User = new User();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  public getRelatedRequestsObjects: RelatedRequests[] = [];
  public isOptionsRebateArrNotValid: boolean = false;
  private defineOptionsRebateResponseObject: ResponseObject = new ResponseObject();
  public isDefineRebateComponent: boolean = true;
  public AdminDecisionDTO: StepDecision = new StepDecision();
  public CircularOptionDTO: CircularsFixedRebateOptionDecisionHistory = new CircularsFixedRebateOptionDecisionHistory();
  addedOptions = [];
  @Output() measurementCommitteeDecisionLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  public isDefineRebateAdmin: boolean = false;
  public isReviewRebateComponent: boolean = false;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  private isFirstStep: boolean = false;
  private isSecondStep: boolean = false;
  private isThirdStep: boolean = false;
  private StepName: string;
  private FormTitle: string;
  private DecisionTitle: string;
  private shipIMONO: string = "";

  constructor(public cookieService: CookieService,public datepipe: DatePipe, private formBuilder: FormBuilder, private alertService: AlertService, private lookupService: LookupService, private circularService: CircularService, private translate: TranslateService, private globalServices: GlobalServices, private cd: ChangeDetectorRef, private router: Router, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
  }
  ngOnInit() {
    this.setDefaults();
    this.loadLookups();
    this.StepName = this.router.url;
    if (this.StepName == '/CircularRequest/FirstStep') {
      this.isFirstStep = true;
      this.FormTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.FIRST_STEP_TITLE');
      this.DecisionTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.FIRST_STEP_DECISION');
    }
    else if (this.StepName == '/CircularRequest/SecondtStep') {
      this.isSecondStep = true;
      this.FormTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.SECOND_STEP_TITLE');
      this.DecisionTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.SECOND_STEP_DECISION');
    }
    else if (this.StepName == '/CircularRequest/ThirdStep') {
      this.isThirdStep = true;
      this.FormTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.THIRD_STEP_TITLE');
      this.DecisionTitle = this.translate.instant('ADMIN_USER.CIRCULARS.ADMIN_DECISION_FORM.THIRD_STEP_DECISION');
    }
  }
  onDecisionChange(): void {
    this.isFormSubmitted = false;
    this.isSubmitEnabled = true;

    switch (this.AdminDecisionForm.controls['ActionType'].value) {
      case Decision.Accept:
        this.onAcceptDecision();
        this.patchValues();
        break;
      case Decision.RequireModification:
        this.onRequireModificationDecision();
        break;
      case Decision.Reject:
        this.onRejectDecision();
        break;
      default:
        break;
    }
  }
  buildAdminDecisionForm(): void {
    this.AdminDecisionForm = this.formBuilder.group({

      Options: this.formBuilder.array([]),
      CircularsLookupId: [''],
      SCID: [''],
      ExNames: [''],
      ActionType: [''],
      SecondStep_WFaction: [''],
      RequireModificationNotesAndComments: [''],
      RejectionReason: ['']
    });

  }
  get f() {
    return this.AdminDecisionForm.controls;
  }
  get Options() {
    return this.AdminDecisionForm.get("Options") as FormArray;
  }
  DeleteOptions() {
    let formArray = this.AdminDecisionForm.get("Options") as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  AddOptions() {
    this.DeleteOptions();
    let control = <FormArray>this.AdminDecisionForm.controls['Options'];
    this.RequestOptions.forEach((key) => {
      control.push(new FormGroup({
        CircularsFixedRebateOptionId: new FormControl(key.Id),
        CircularsFixedRebateOptionNameFrom: new FormControl(''),
        CircularsFixedRebateOptionNameTo: new FormControl(''),
        CircularsPercentagesId: new FormControl('', [Validators.required]),
        Notes: new FormControl(''),
        isGranted: new FormControl('')
      }));
    });

  }

  onAcceptDecision(): void {
    this.AddOptions();
    if (this.AdminDecisionForm.controls["RequireModificationNotesAndComments"]) {
      this.AdminDecisionForm.removeControl('RequireModificationNotesAndComments');
    }
    if (this.AdminDecisionForm.controls["RejectionReason"]) {
      this.AdminDecisionForm.removeControl('RejectionReason');
    }
    if (this.Options) {
      this.Options.controls.forEach(element => {

        element.get("isGranted").setValidators([Validators.required]);


      });
      this.Options.updateValueAndValidity();
    }
    if (this.isSecondStep) {
      this.AdminDecisionForm.addControl('SecondStep_WFaction', this.formBuilder.control(null));
      this.AdminDecisionForm.controls["SecondStep_WFaction"].setValidators([Validators.required]);

    }
    this.Options.controls.forEach(element => {
      element.get("CircularsPercentagesId").disable();
      element.get("CircularsFixedRebateOptionNameFrom").disable();
      element.get("CircularsFixedRebateOptionNameTo").disable();
      //element.get("isGranted").setValidators([Validators.required]);


    });
    this.AdminDecisionForm.updateValueAndValidity();
    this.RequestId = this.CircularRequest.rebateRequestLoaded.Id;
    this.CircularID = this.CircularRequest.rebateRequestLoaded.CircularsLookupId;
    this.isRequireModification = false;
    this.isAccept = true;
    this.isReject = false;
    this.AdminDecisionForm.controls['CircularsLookupId'].disable();

    const optionsArray = <FormArray>this.AdminDecisionForm.controls['Options'];
    for (let i: number = 0; i < this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions.length; i++) {
      let x = i + 1;
      if (this.isFirstStep) {
        optionsArray.controls[i].patchValue({
          //CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
          CircularsFixedRebateOptionNameFrom:"Option " + x + " "+  this.OriginsArrPorts[i].Text +  " - " + this.OriginsArrCountries[i].Text + " - " + this.OriginsArr[i].Text,
          CircularsFixedRebateOptionNameTo:"Option " + x + " "+  this.DestinationsArrPorts[i].Text +  " - " + this.DestinationsArrCountries[i].Text + " - " + this.DestinationsArr[i].Text,
          //CircularsFixedRebateOptionNameTo:#Option {{i + 1}} {{DestinationsArrPorts[i].Text}} - {{DestinationsArrCountries[i].Text}} - {{DestinationsArr[i].Text}}
        })
      }
      else {
        optionsArray.controls[i].patchValue({
          CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
          Notes: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].ApprovalNote,
          isGranted: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].IsGranted,
          CircularsFixedRebateOptionNameFrom:"Option " + x + " "+   this.OriginsArrPorts[i].Text +  " - " + this.OriginsArrCountries[i].Text + " - " + this.OriginsArr[i].Text,
          CircularsFixedRebateOptionNameTo:"Option " + x + " "+  this.DestinationsArrPorts[i].Text +  " - " + this.DestinationsArrCountries[i].Text + " - " + this.DestinationsArr[i].Text,
        })
      }
    }

    // const optionsArray = <FormArray>this.AdminDecisionForm.controls['Options'];
    // for (let i: number = 0; i < this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions.length; i++) {
    //   if (this.isFirstStep) {
    //     optionsArray.controls[i].patchValue({
    //       CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
    //     })
    //   }
    //   else {
    //     optionsArray.controls[i].patchValue({
    //       CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
    //       Notes: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].ApprovalNote,
    //       isGranted: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].IsGranted,
    //     })
    //   }
    // }
    // this.AdminDecisionForm.patchValue({
    //   CircularsLookupId: this.CircularID,
    //   SCID: this.CircularRequest.rebateRequestLoaded.AdminSCID,
    // });
  }
  onRequireModificationDecision(): void {

    this.DeleteOptions();
    if (this.AdminDecisionForm.controls["SecondStep_WFaction"]) {
      this.AdminDecisionForm.removeControl('SecondStep_WFaction');
    }
    if (this.AdminDecisionForm.controls["RejectionReason"]) {
      this.AdminDecisionForm.removeControl('RejectionReason');
    }
    this.AdminDecisionForm.addControl('RequireModificationNotesAndComments', this.formBuilder.control(null));
    this.AdminDecisionForm.controls["RequireModificationNotesAndComments"].setValidators([Validators.required]);
    this.AdminDecisionForm.updateValueAndValidity();
    this.isRequireModification = true;
    this.isAccept = false;
    this.isReject = false;
  }
  onRejectDecision(): void {
    this.DeleteOptions();
    if (this.AdminDecisionForm.controls["SecondStep_WFaction"]) {
      this.AdminDecisionForm.removeControl('SecondStep_WFaction');
    }
    if (this.AdminDecisionForm.controls["RequireModificationNotesAndComments"]) {
      this.AdminDecisionForm.removeControl('RequireModificationNotesAndComments');
    }
    this.AdminDecisionForm.addControl('RejectionReason', this.formBuilder.control(null));
    this.AdminDecisionForm.controls["RejectionReason"].setValidators([Validators.required]);
    //this.Options.controls['CircularsPercentagesId'].disable();
    this.AdminDecisionForm.updateValueAndValidity();
    this.isAccept = false;
    this.isRequireModification = false;
    this.isReject = true;
  }

  onRebateRequestLoadedFlag(flag: boolean) {

    if (flag) {
      this.globalServices.IsLoaderEnabled = true;
      this.RequestId = this.CircularRequest.rebateRequestLoaded.Id;
      this.CircularID = this.CircularRequest.rebateRequestLoaded.CircularsLookupId;
      this.RequestStatus = this.CircularRequest.rebateRequestLoaded.InternalStatusId;
      this.shipIMONO = this.CircularRequest.rebateRequestLoaded.IMONo
      this.LoadPercentages();
      this.loadRelatedRequests();
    }
  }
  // fillMeasurementAcceptedRequestObject(): void {
  //   if (this.formMode == FormMode.DetailsAccept) {
  //     //Open Accept Form
  //     this.isAccept = true;
  //     this.AdminDecisionForm.controls['CircularsLookupId'].disable();
  //   } else if (this.formMode == FormMode.DetailsReject) {
  //     //Open Reject Form
  //     this.isReject = true;
  //     this.isAccept = false;
  //   }
  //   //Disable Form
  //   this.AdminDecisionForm.disable();
  //   //Fill Form Decision
  //   this.AdminDecisionForm.patchValue({
  //     ActionType: this.AdminDecisionDTO.ActionType.toString()
  //   });
  //   if (this.formMode == FormMode.DetailsAccept) {
  //   } else if (this.formMode == FormMode.DetailsReject) {
  //     this.AdminDecisionForm.patchValue({
  //       //  RejectionReason: this.AdminDecisionDTO.RejectionReason
  //     });
  //   }
  //   this.cd.detectChanges();
  // }

  setDefaults(): void {
    this.buildAdminDecisionForm();
  }
  loadLookups(): void {
    this.loadCirculars();

  }
  LoadPercentages(): void {
    this.circularService.getPercentagesByCircularId(this.CircularID).subscribe(
      data => this.Percentages = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.loadPercentagesCompleted()
    );
  }
  loadRelatedRequests(): void {
    this.circularService.getRelatedRequests(this.shipIMONO, this.RequestId).subscribe(
      data => this.getRelatedRequestsResponse = data,
      () => console.log("Something went wrong!!"),
      () => this.loadRelatedRequestsCompleted()
    );
  }
  loadRelatedRequestsCompleted(): void {
    if (this.getRelatedRequestsResponse.Success) {
      this.getRelatedRequestsObjects = this.getRelatedRequestsResponse.Data as RelatedRequests[];
     /* this.getRelatedRequestsObjects.forEach(element => {
        if(element.Status=="No Rebate"){
          element.Status = "Normal Tolls";
        }
      }
      );*/
    } else {
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      this.globalServices.isLoaderEnabled = false;
    }
  }
  loadPercentagesCompleted(): void {
    // this.Percentages.sort((a, b) => (a.PercentageValue > b.PercentageValue) ? 1 : -1);
    this.RequestOptions = this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions;
    //this.RequestOptions.sort((a, b) => (a. > b.PercentageValue) ? 1 : -1);

    this.CircularRequest.showOptionDev = false;
    this.ports = this.CircularRequest.ports;
    this.Countries = this.CircularRequest.countries;
    this.CircularRequest.editModeAdmin = true;

    this.fillRegionsDictionary();
    this.fillPortsDictionary();
    this.fillCountriesDictionary();
    this.setFormMode();
    // if(this.isSecondStep || this.isThirdStep){
    //   this.AdminDecisionForm.patchValue({
    //     ActionType: Decision.Accept,
    //   });
    //   this.onAcceptDecision();
    // }
  }
  setFormMode(): void {
    if (history.state.data && history.state.data.isCompleted) {
      this.formMode = FormMode.Readonly;
      if (this.RequestStatus == ServiceStatus.Circulars_MoreInformationRequestedFromAgent ||
        this.RequestStatus == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester) {
        this.onRequireModificationDecision();
      }
      else if (this.RequestStatus == ServiceStatus.Circulars_Rejected) {
        this.onRejectDecision();
      }
      else {
        this.onAcceptDecision();
      }
      this.patchValues();
      this.AdminDecisionForm.disable();
    }
    //first step
    else if (this.isFirstStep) {

      this.formMode = FormMode.Add;
      this.AdminDecisionForm.enable();
    }
    // second or third step
    else if (this.isSecondStep || this.isThirdStep) {
      this.formMode = FormMode.Add;
      this.AdminDecisionForm.enable();
      this.onAcceptDecision();
      this.patchValues();
    }
    else {
      this.formMode = FormMode.Readonly;
      this.onAcceptDecision();
      this.patchValues();
      this.AdminDecisionForm.disable()
    }
  }

  patchValues() {
    //Add Mode
    let ex = "";
    if (this.CircularRequest.rebateRequestLoaded.AdminExNames == null) {
      ex = this.CircularRequest.rebateRequestLoaded.ExNames;
    }
    else {
      ex = this.CircularRequest.rebateRequestLoaded.AdminExNames;
    }
    if (this.formMode == FormMode.Add) {
      if (this.isFirstStep) {
        this.AdminDecisionForm.patchValue({
          CircularsLookupId: this.CircularID,
          SCID: this.CircularRequest.rebateRequestLoaded.SCID,
          ExNames: ex
        });
      }
      else if (this.isSecondStep || this.isThirdStep) {
        this.AdminDecisionForm.patchValue({
          ActionType: Decision.Accept,
          CircularsLookupId: this.CircularID,
          SCID: this.CircularRequest.rebateRequestLoaded.AdminSCID,
          ExNames: ex
        });
      }

      const optionsArray = <FormArray>this.AdminDecisionForm.controls['Options'];
      for (let i: number = 0; i < this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions.length; i++) {

        if (this.isFirstStep) {
          optionsArray.controls[i].patchValue({
            CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
          });
        }
        else {
          optionsArray.controls[i].patchValue({
            CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
            Notes: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].ApprovalNote,
            isGranted: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].IsGranted,
          });
        }
      }

    }
    //ReadOnly Mode
    else if (this.formMode == FormMode.Readonly) {
      if (this.RequestStatus == ServiceStatus.Circulars_MoreInformationRequestedFromAgent ||
        this.RequestStatus == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester) {

        this.AdminDecisionForm.patchValue({
          ActionType: Decision.RequireModification,
          RequireModificationNotesAndComments: this.CircularRequest.requireModificationNotes
        });
      }
      else if (this.RequestStatus == ServiceStatus.Circulars_Rejected) {
        this.AdminDecisionForm.patchValue({
          ActionType: Decision.Reject,
          RejectionReason: this.CircularRequest.rebateRequestLoaded.AdminRejectionReason
        });
      }
      else {

        this.AdminDecisionForm.patchValue({
          ActionType: Decision.Accept,
          CircularsLookupId: this.CircularID,
          SCID: this.CircularRequest.rebateRequestLoaded.AdminSCID,
          ExNames: ex
        });

        const optionsArray = <FormArray>this.AdminDecisionForm.controls['Options'];
        for (let i: number = 0; i < this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions.length; i++) {
          optionsArray.controls[i].patchValue({
            CircularsPercentagesId: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
            Notes: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].ApprovalNote,
            isGranted: this.CircularRequest.rebateRequestLoaded.CircularsFixedRebateOptions[i].IsGranted,
          });
        }
      }
    }

  }
  loadCirculars(): void {
    this.lookupService.getCirculars().subscribe(

      data => this.circulars = data.Data as Circular[],

      () => console.log("Something went wrong!!"),
    );
  }
  relatedRequestDetails(relatedRequestIndex: number): void {
    localStorage.setItem('lsRebateRequestId', this.getRelatedRequestsObjects[relatedRequestIndex].Id);
    this.cookieService.set('RelatedRequestId',this.getRelatedRequestsObjects[relatedRequestIndex].Id);
    if (this.getRelatedRequestsObjects[relatedRequestIndex].serviceName == 'Circulars') {

      window.open('#/CircularRequest/BaseRequestDetails', '_blank');
    }
    else if (this.getRelatedRequestsObjects[relatedRequestIndex].serviceName == 'Long Haul') {
      localStorage.setItem('lsRebateRequestId', this.getRelatedRequestsObjects[relatedRequestIndex].Id);
      window.open('#/RebateRequest/BaseRequestDetails', '_blank');
    }
  }
  submit(): void {
    this.isFormSubmitted = true;
    if (this.AdminDecisionForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalServices.isLoaderEnabled = true;
    this.loading = true;
    this.AdminDecisionDTO.ActivityInstanceID = this.CircularRequest.rebateRequestLoaded.ActivityInstanceID;
    this.AdminDecisionDTO.StepName = this.StepName;

    this.AdminDecisionDTO.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.AdminDecisionDTO.ActionType = this.AdminDecisionForm.controls['ActionType'].value;
    if (this.AdminDecisionForm.controls['ActionType'].value == Decision.Accept) {
      this.AdminDecisionDTO.SecondStep_WFaction = this.AdminDecisionForm.controls['SecondStep_WFaction'].value;
      this.AdminDecisionDTO.SCID = this.AdminDecisionForm.controls['SCID'].value;
      this.AdminDecisionDTO.ExNames = this.AdminDecisionForm.controls['ExNames'].value;
    }
    this.AdminDecisionDTO.CircularFixedRebateRequestId = this.RequestId;

    switch (this.AdminDecisionForm.controls['ActionType'].value) {
      case Decision.Accept:
        this.AdminDecisionDTO.comment = ""
        this.Options.controls.forEach(element => {
          this.CircularOptionDTO = new CircularsFixedRebateOptionDecisionHistory();
          this.CircularOptionDTO.CircularFixedRebateRequestId = this.RequestId;
          this.CircularOptionDTO.CircularsFixedRebateOptionsId = element.value.CircularsFixedRebateOptionId;
          this.CircularOptionDTO.CircularsPercentagesId = element.get("CircularsPercentagesId").value;
          this.CircularOptionDTO.Notes = element.value.Notes;
          this.CircularOptionDTO.isGranted = element.value.isGranted;
          this.addedOptions.push(this.CircularOptionDTO);
        });
        this.AdminDecisionDTO.CircularsFixedRebateOptionDecisionHistory = this.addedOptions
        break;
      case Decision.RequireModification:
        this.AdminDecisionDTO.comment = this.AdminDecisionForm.controls['RequireModificationNotesAndComments'].value

        this.AdminDecisionDTO.CircularsFixedRebateOptionDecisionHistory = this.addedOptions;
        break;
      case Decision.Reject:
        this.AdminDecisionDTO.comment = this.AdminDecisionForm.controls['RejectionReason'].value

        this.AdminDecisionDTO.CircularsFixedRebateOptionDecisionHistory = this.addedOptions;
        break;
      default:
        break;
    }

    if (this.RequestId && this.RequestId != "")
      this.submitDecision();

  }

  submitDecision(): void {
    this.circularService.SubmitAdminDecision(this.AdminDecisionDTO).subscribe(
      data => this.submitMeasurementCommitteeDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitMeasurementCommitteeDecisionCompleted()
    );
  }
  /* submitMeasurementCommitteeDecision(): void {
     this.longHaulService.submitMeasurementCommitteeDecision(this.firstDecisionObject).subscribe(
       data => this.submitMeasurementCommitteeDecisionResponseObject = data,
       () => console.log("Something went wrong!!"),
       () => this.submitMeasurementCommitteeDecisionCompleted()
     );
   }*/
  submitMeasurementCommitteeDecisionCompleted(): void {
    if (!this.submitMeasurementCommitteeDecisionResponseObject.Success) {
      if (this.submitMeasurementCommitteeDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.submitMeasurementCommitteeDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }

  fillRegionsDictionary(): void {
    for (let i: number = 0; i < this.RequestOptions.length; i++) {
      this.OriginsArr[i] = new OptionKey();
      this.OriginsArr[i].Index = i;
      this.OriginsArr[i].Text = this.Percentages.filter(p => p.Id == this.RequestOptions[i].CircularsPercentagesId)[0].CircularsRegions.NameEN;
      //this.OriginsArr[i].Value = this.RequestOptions[i].LastPortOriginId;
      this.DestinationsArr[i] = new OptionKey();
      this.DestinationsArr[i].Index = i;
      this.DestinationsArr[i].Text = this.Percentages.filter(p => p.Id == this.RequestOptions[i].CircularsPercentagesId)[0].CircularsRegions1.NameEN;
      //this.DestinationsArr[i].Value = this.RequestOptions[i].LastPortOriginId;
      //this.RequestOptions[i].NumericSuggestedRebate = +this.RequestOptions[i].SuggestedRebate;
    }
  }
  fillCountriesDictionary(): void {
    for (let i: number = 0; i < this.RequestOptions.length; i++) {
      this.OriginsArrCountries[i] = new OptionKey();
      this.OriginsArrCountries[i].Index = i;
      this.OriginsArrCountries[i].Text = this.RequestOptions[i].LastCountryOriginId != -1 && this.RequestOptions[i].LastCountryOriginId != null ? this.Countries.filter(c => c.Id == this.RequestOptions[i].LastCountryOriginId)[0].NameEN : "";
      /*if (this.OriginsArrCountries[i].Text != "") {
        this.OriginsArrCountries[i].Text += " - "

      }*/

      this.DestinationsArrCountries[i] = new OptionKey();
      this.DestinationsArrCountries[i].Index = i;
      this.DestinationsArrCountries[i].Text = this.RequestOptions[i].FirstCountryDestinationId != -1 && this.RequestOptions[i].FirstCountryDestinationId != null ? this.Countries.filter(c => c.Id == this.RequestOptions[i].FirstCountryDestinationId)[0].NameEN   :  "";
      /*if (this.DestinationsArrCountries[i].Text != "") {
        this.DestinationsArrCountries[i].Text += " - "
      }*/
    }
  }

  fillPortsDictionary(): void {
    for (let i: number = 0; i < this.RequestOptions.length; i++) {
      this.OriginsArrPorts[i] = new OptionKey();
      this.OriginsArrPorts[i].Index = i;
      this.OriginsArrPorts[i].Text = this.RequestOptions[i].LastPortOriginId != -1 && this.RequestOptions[i].LastPortOriginId != null ? this.ports.filter(c => c.Id == this.RequestOptions[i].LastPortOriginId)[0].NameEN : this.RequestOptions[i].OtherLastPortOrigin;
      /*if (this.OriginsArrPorts[i].Text != "") {
        this.OriginsArrPorts[i].Text += " - "

      }*/

      this.DestinationsArrPorts[i] = new OptionKey();
      this.DestinationsArrPorts[i].Index = i;
      this.DestinationsArrPorts[i].Text = this.RequestOptions[i].FirstPortDestinationId != -1 && this.RequestOptions[i].FirstPortDestinationId != null ? this.ports.filter(c => c.Id == this.RequestOptions[i].FirstPortDestinationId)[0].NameEN : this.RequestOptions[i].OtherFirstPortDestination;
      /*if (this.DestinationsArrPorts[i].Text != "") {
        this.DestinationsArrPorts[i].Text += " - "
      }*/
    }
  }

  later(): void {
    this.router.navigateByUrl('/CircularsTasksDirectory');
  }

}

enum Decision {
  Accept = "1",
  RequireModification = "2",
  Reject = "3"
}

// enum FormMode {
//   New = 1,
//   Edit = 2,
//   DetailsAccept = 3,
//   DetailsReject = 4,
//   Readonly = 5
// }

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
